import * as React from 'react';
import styled from 'styled-components';
import {ConstBreakPoint} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement> {
}

const TrDefault: React.FC<IProps> = (props) => {

    const { ...TrProps } = props;

    return(<tr {...TrProps} />);

};

const Tr = styled(TrDefault)`
    display: block;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: table-row;
    }
`;

export default Tr;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/tr.tsx